var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C2.55228 2 3 2.44772 3 3V20C3 21.6569 4.34315 23 6 23H24C24.5523 23 25 23.4477 25 24C25 24.5523 24.5523 25 24 25H6C3.23858 25 1 22.7614 1 20V3C1 2.44772 1.44772 2 2 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6466 13.0607L8.06077 17.6464C7.67025 18.037 7.03708 18.037 6.64656 17.6464C6.25604 17.2559 6.25603 16.6227 6.64656 16.2322L11.9395 10.9393C12.33 10.5488 12.9631 10.5488 13.3537 10.9393L15.5001 13.0857L21.0859 7.49995C21.4764 7.10943 22.1096 7.10943 22.5001 7.49995C22.8906 7.89048 22.8906 8.52364 22.5001 8.91417L16.2072 15.2071C15.8167 15.5976 15.1835 15.5976 14.793 15.2071L12.6466 13.0607Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMetrics);
export default __webpack_public_path__ + "static/media/menu-metrics.4df383cc4700d568302b192462d3e97e.svg";
export { ForwardRef as ReactComponent };